export const engagementJumpstartContentBlocks = "/engagement/jumpstart_content_blocks/:id";
